import { render, staticRenderFns } from "./TabContasReceber.vue?vue&type=template&id=295bc9dd&scoped=true&"
import script from "./TabContasReceber.vue?vue&type=script&lang=js&"
export * from "./TabContasReceber.vue?vue&type=script&lang=js&"
import style0 from "./TabContasReceber.vue?vue&type=style&index=0&id=295bc9dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295bc9dd",
  null
  
)

export default component.exports